import React, { useEffect } from 'react';
import { useNotification } from 'src/hooks/useNotification';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { stringScheme } from 'src/utils/validation-schemes';
import Input from 'src/components/Input/Input';
import { Button } from 'src/components/ui/button';
import { useCreateKnowledgeBaseMutation } from 'src/services/knowledgeBaseService';

export const CreateKnowledgeBaseForm = ({
  close = () => {},
  onCreate = (() => {}) as (id?: any) => void,
}) => {
  const notification = useNotification();

  const [createKnowledgeBase, { data, isLoading, isSuccess }] =
    useCreateKnowledgeBaseMutation() as any;

  useEffect(() => {
    if (data) {
      onCreate(data.id);
      close();
    }
  }, [data]);

  useEffect(() => {
    if (isSuccess) {
      notification.success('Knowledge Base was successfully created!');
    }
  }, [isLoading, isSuccess]);

  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      name: '',
    },
    resolver: yupResolver(
      object({
        name: stringScheme({ required: true })
          .label('Name')
          .max(50, 'The name of your Knowledge Base cannot exceed 50 characters.'),
      }),
    ),
  });

  const submit = (data) => {
    createKnowledgeBase({
      name: data.name,
    }).then(() => reset());
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(submit)();
      }}
    >
      <div className="content">
        <Controller
          control={control}
          name="name"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Name'}
              placeholder={'AI Knowledge Base'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
            />
          )}
        />
      </div>
      <div className="flex justify-center mt-5">
        <div className="flex gap-2.5">
          <Button variant="outline" type="button" className="min-w-24" onClick={close}>
            Cancel
          </Button>
          <Button disabled={!isDirty || isLoading} type="submit" className="min-w-24">
            {isLoading ? 'Loading...' : 'Create'}
          </Button>
        </div>
      </div>
    </form>
  );
};
